import { render } from "./CurrencyManage.vue?vue&type=template&id=4e60b736"
import script from "./CurrencyManage.vue?vue&type=script&lang=js"
export * from "./CurrencyManage.vue?vue&type=script&lang=js"

import "./CurrencyManage.vue?vue&type=style&index=0&id=4e60b736&lang=less"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__